import { get, getAuthenticatedRequestConfig } from '../client'
import { productsIndexSerializer } from '../../serializers/getProductsIndexSerializer'

export const getProductsIndexResource = async (params = {}) =>
  // eslint-disable-next-line implicit-arrow-linebreak
  get('/v1/products', { ...params })
    .then((response) => productsIndexSerializer(response))
    .catch((error) => Promise.reject(error))

export const getAuthenticatedProductsIndexResource = (
  baseURL,
  authToken,
  authHeader,
  authScheme,
  params = {}
) => {
  const requestConfig = getAuthenticatedRequestConfig(
    baseURL,
    authToken,
    authHeader,
    authScheme,
    params
  )

  return getProductsIndexResource(requestConfig)
}

export default getProductsIndexResource
